module.exports = __webpack_public_path__ + "static/mobile_wireframe_cover-70a7be74edb1ead9f0765b1f04e7c5b1.png";